import { gql } from '@apollo/client';

export const UPDATE_NUMERIC_PRECISION = gql`
  mutation updateFieldDecimalPlacesConfig($input: FieldDecimalPlaceInput!) {
    updateFieldDecimalPlacesConfig(input: $input) {
      commandId
    }
  }
`;
